























































import { useGlobals }                     from '@/hooks/use-globals';
import { computed, defineComponent, reactive, Ref, ref, watch } from '@vue/composition-api';
import CColorPicker                       from '@/components/color-picker/color-picker.component.vue';
import cBreadcrumb                        from '@/components/breadcrumb/breadcrumb.component.vue';
import CInput                             from '@/components/form/input/input.component.vue';
import CInputNumber                       from '@/components/form/input-number/input-number.component.vue';
import CButton                            from '@/components/form/button/button.component.vue';
import CFooterPanel                       from '@/components/footer-panel/footer-panel.component.vue';
import { HeatMapValues }                  from '@/views/heat-map-configuration/heat-map-configuration.types';
import { TranslateResult }                from 'vue-i18n';

export default defineComponent({
  name: 'vHeatMapConfiguration',
  components: {
    CButton,
    CInput,
    CInputNumber,
    CColorPicker,
    cBreadcrumb,
    CFooterPanel,
  },
  setup() {
    const { i18n, store } = useGlobals();
    const heatMapInitialValues = computed((): HeatMapValues[] => store.state.views.vHeatMapConfiguration.heatMapValues);
    const getBreadcrumbTranslation = computed((): TranslateResult => i18n.t('vHeatMapConfiguration.meta.breadcrumb'));
    const getTranslation = (value: string): string => ref(i18n.t(`vHeatMapConfiguration.heatMapConfiguration.${value}`))
      .value
      .toString();

    const heatMapValues: Ref<number[]> = ref([]);
    const heatMapColors: Ref<string[]> = ref([]);

    const saveConfiguration = async () => {
      const heatMapSendValues: Ref<HeatMapValues[]> = ref([]);

      heatMapInitialValues.value.forEach((_, index) => {
        const configRow = reactive({
          color: heatMapColors.value[ index ],
          occupancyFrom: heatMapValues.value[ index ],
          occupancyTo: heatMapValues.value[ index + 1 ],
        });

        heatMapSendValues.value.push(configRow);
      });

      store.commit('views/vHeatMapConfiguration/setHeatMapConfiguration', heatMapSendValues.value);
      await store.dispatch('views/vHeatMapConfiguration/putHeatMapConfiguration', heatMapSendValues.value);
      await store.dispatch('views/vHeatMapConfiguration/getHeatMapValues');
    };

    store.dispatch('views/vHeatMapConfiguration/getHeatMapValues');

    watch(heatMapInitialValues, () => {
      if (heatMapInitialValues.value.length) {
        heatMapInitialValues.value.forEach((item) => {
          heatMapValues.value.push(item.occupancyFrom!);
          heatMapColors.value.push(item.color!);
        });

        heatMapValues.value.push(100);
      }
    });

    return {
      saveConfiguration,
      getTranslation,
      heatMapInitialValues,
      heatMapValues,
      heatMapColors,
      getBreadcrumbTranslation,
    };
  },
});

